var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha } from '@mui/material';
import { makeStateLayer } from '../styles';
export var standardStyle = {
    '&:not(:disabled)': function (theme) {
        return makeStateLayer(theme.palette.background.paper);
    },
    '&:disabled': { opacity: 0.38 },
    svg: {
        color: 'surfaceVariant.onColor',
    },
};
export var filledStyle = {
    opacity: 1,
    backgroundColor: 'secondary.main',
    svg: {
        color: 'secondary.contrastText',
    },
    '&:not(:disabled)': function (theme) { return (__assign(__assign({}, makeStateLayer(theme.palette.secondary.main)), { backgroundColor: 'secondary.main' })); },
    '&:disabled': {
        backgroundColor: function (theme) {
            return alpha(theme.palette.background.paper, 0.12);
        },
    },
};
export var tonalStyle = {
    backgroundColor: 'primary.main',
    svg: {
        color: 'primary.contrastText',
    },
    '&:not(:disabled)': function (theme) {
        return makeStateLayer(theme.palette.primary.main);
    },
    '&:disabled': {
        backgroundColor: function (theme) {
            return alpha(theme.palette.background.paper, 0.12);
        },
    },
};
export var outlinedStyle = {
    border: 'solid 1px',
    borderColor: 'outline.main',
    svg: {
        color: 'surfaceVariant.contrastText',
    },
    '&:not(:disabled)': function (theme) {
        return makeStateLayer(theme.palette.background.paper);
    },
    '&:disabled': {
        borderColor: function (theme) { return alpha(theme.palette.outline.main, 0.12); },
        '& svg': {
            opacity: 0.38,
            color: 'surfaceVariant.contrastText',
        },
    },
};
